// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__100my"};